import React from "react";
import { useLocation, Navigate, Outlet, useNavigate } from "react-router-dom";
import jwt_decode from "jwt-decode";
// import localStorage from 'universal-cookie';
// import LogoAnimation from "../Animations/LogoAnimation";
// import Login from "../login/Login";
import { getToken, getDecryptMsisdn } from "../../ApiCalls/Auth/api_v1_auth";
import { useEffect, useState } from "react";
import Loader from '../Animations/Loader';
import { CircleNotifications } from "@mui/icons-material";
import { getLoginUrl } from '../../ApiCalls/axiosClient';

const useAuth = () => {
    let isTokenAvailable = localStorage.getItem("token");
    const current = new Date();
    const nextYear = new Date();
    nextYear.setFullYear(current.getFullYear() + 1);
    let location = useLocation();
    const [loggedIn, setLoggedIn] = useState(null);
    const src = new URLSearchParams(window.location.search).get("source");
    let ndnc = 0;
    const navigate = useNavigate();
    useEffect(() => {

        const loginWithToken = async (token) => {
            try {
                const decoded = jwt_decode(token);
                const msisdn = decoded.userInfo?.msisdn;

                if (msisdn && msisdn.toString().length <= 12) {
                    setLoggedIn(true);
                    return true;
                }

                setLoggedIn(false);
                return false;
            } catch (e) {
                setLoggedIn(false);
                return false;
            }
        };

        const loginWithUrlParam = async () => {
            const msisdnFromUrl = new URLSearchParams(window.location.search).get("a");
            if (!msisdnFromUrl) return false;
            localStorage.removeItem('token');
            localStorage.removeItem('u');
            try {
                const tokenResponse = await getToken({ msisdn: msisdnFromUrl });

                const accessToken =
                    tokenResponse.headers['access_token'] ||
                    tokenResponse.headers['Access_token'] ||
                    tokenResponse.headers['ACCESS_TOKEN'];

                if (!accessToken) { setLoggedIn(false); return false };

                const decoded = jwt_decode(accessToken);
                const dw = decoded.userInfo?.dw;

                localStorage.setItem('token', accessToken);
                localStorage.setItem('u', msisdnFromUrl);
                if (dw) localStorage.setItem('dw', dw);

                await loginWithToken(accessToken);

                navigate("/home", { replace: true });
                return true;

            } catch (err) {
                console.error("Token fetch failed:", err);
                return false;
            }
        };

        const initAuth = async () => {

            // FIRST: URL PARAM
            const urlHandled = await loginWithUrlParam();
            if (urlHandled) return;

            // SECOND: LOCAL STORAGE
            const storedToken = localStorage.getItem('token');
            const storedMsisdn = localStorage.getItem('u');

            if (storedToken && storedMsisdn) {
                const ok = await loginWithToken(storedToken);
                if (ok) return;
            }

            // LAST: REDIRECT
            const redirectURL = getLoginUrl();
            window.location.href = redirectURL;
        };

        initAuth();

    }, [location.pathname]);

    return loggedIn
}


const ProtectedRoutes = () => {
    let location = useLocation();
    const isAuth = useAuth();
    let isUuidExp = localStorage.getItem('uid_exp');
    // console.log(isAuth);
    if (isAuth === null) // waiting..
    { return <Loader />; }
    // <LogoAnimation />;

    // if(isAuth &&  location.pathname==="/" || location.pathname==="/login")
    // {
    //     // console.log(location.pathname);    
    //      return <Navigate to="/home" />
    // }
    if (location.pathname === "/share/watch") {
        // console.log(location.pathname);    
        return <Outlet />
    }

    const redirectURL = getLoginUrl();

    return isUuidExp == 1 ? window.location.href = redirectURL : isAuth ? <Outlet /> : window.location.href = redirectURL
}


export default React.memo(ProtectedRoutes);